import { ReactElement } from "react";
import useGlobal from "../logic/hooks/useGlobal";

export const OverlayModal = ({ 
  children, 
  isWhiteLabel = null 
}: { 
  children: ReactElement;
  isWhiteLabel?: boolean | null;
}) => {
  const [colorMode] = useGlobal(["colormode", "selected"]);
  // null = undetermined (don't show branding yet to avoid flash)
  // false = show branding
  // true = hide branding (white label)
  const showBranding = isWhiteLabel === false;
  
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[9999]"
      style={{
        background: colorMode === "light" ? "rgba(8, 8, 8, 0.75)" : "rgba(20, 20, 20, 0.85)",
      }}
    >
      <div 
        style={{
          width: '375px',
          height: '720px',
          maxWidth: '100%',
          maxHeight: '100%',
          position: 'relative',
        }}
      >
        <div
          className={`${showBranding ? 'rounded-t-xl' : 'rounded-xl'} w-full overflow-hidden bg-background`}
          style={{
            height: showBranding ? 'calc(100% - 40px)' : '100%',
            position: 'relative',
            zIndex: 100,
          }}
        >
          {children}
        </div>
        {showBranding && (
          <div
            className="rounded-b-xl w-full flex items-center justify-center bg-subtle"
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 99,
              height: '60px',
              paddingTop: '32px',
              paddingBottom: '12px',
            }}
          >
            <a href="https://picaos.com" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center">
              <div className="flex items-center gap-1">
                <span className="text-[11px] text-muted-foreground">
                  Secured by
                </span>
                <img 
                  src={colorMode === "light" ? "/solo-light.svg" : "/solo-dark.svg"} 
                  className="h-[13px]" 
                  alt="AuthKit logo" 
                />
                <span className="text-[11px] text-muted-foreground">
                  Pica
                </span>
              </div>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
